import { auth } from '@/state/auth'
import axios from 'axios'
import type { Repository } from 'functions/_utils/types'
import { create } from 'zustand'

type RepoListState = {
  loading: boolean
  empty: boolean
  list: Repository[]
  fetch(): Promise<void>
  reset(): void
}

export const useRepoListState = create<RepoListState>(set => ({
  empty: false,
  loading: false,
  list: [],

  fetch: async () => {
    set({ loading: true })
    try {
      const { data } = await auth(token => (
        axios.get<Repository[]>('/api/repositories', {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
      ))
      set({
        list: data,
        empty: data.length === 0,
      })
    }
    catch (e) {
      console.error(e)
      set({ list: [] })
    }
    finally {
      set({ loading: false })
    }
  },

  reset: () => {
    set({
      list: [],
      loading: false,
      empty: false,
    })
  },
}))
